/* eslint-disable react/require-default-props */
import React from 'react';
import { Button, Typography } from '@mui/material';

type Props = {
  name: string;
  buttonText?: string | React.ReactNode;
  buttonAction?: () => void;
};

export default function SectionHeader({
  name,
  buttonText,
  buttonAction,
}: Props) {
  if (!name) return null;
  return (
    <div className="section-header">
      <Typography variant="h3">{name}</Typography>
      {buttonText && buttonAction && (
        <Button
          variant="text"
          className="text-btn"
          onClick={buttonAction}
          sx={
            typeof buttonText === 'string'
              ? undefined
              : {
                  minWidth: 0,
                  paddingY: 0,
                  paddingX: 2,
                }
          }>
          {buttonText}
        </Button>
      )}
    </div>
  );
}
